var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-grid',{staticClass:"settings-toggle",attrs:{"align-items":"center"}},[_c('flex-grid-item',{attrs:{"grow":"1"}},[_c('label',{attrs:{"for":_vm.name}},[_vm._v(" "+_vm._s(_vm.label)+" ")])]),_c('flex-grid-item',[_c('toggle-button',{attrs:{"labels":true,"name":_vm.name,"value":_vm.value},on:{"change":_vm.onChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }